/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadStageCount } from './LeadStageCount';
import {
    LeadStageCountFromJSON,
    LeadStageCountFromJSONTyped,
    LeadStageCountToJSON,
    LeadStageCountToJSONTyped,
} from './LeadStageCount';

/**
 * 
 * @export
 * @interface GetLeadStageCounts200Response
 */
export interface GetLeadStageCounts200Response {
    /**
     * 
     */
    data?: Array<LeadStageCount>;
}

/**
 * Check if a given object implements the GetLeadStageCounts200Response interface.
 */
export function instanceOfGetLeadStageCounts200Response(value: object): value is GetLeadStageCounts200Response {
    return true;
}

export function GetLeadStageCounts200ResponseFromJSON(json: any): GetLeadStageCounts200Response {
    return GetLeadStageCounts200ResponseFromJSONTyped(json, false);
}

export function GetLeadStageCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadStageCounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadStageCountFromJSON)),
    };
}

export function GetLeadStageCounts200ResponseToJSON(json: any): GetLeadStageCounts200Response {
    return GetLeadStageCounts200ResponseToJSONTyped(json, false);
}

export function GetLeadStageCounts200ResponseToJSONTyped(value?: GetLeadStageCounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadStageCountToJSON)),
    };
}

